import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ISeatInfo } from '../../../context/SystemContext/useSeat';
import SeatContent from './SeatContent';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: ISeatInfo;
  isPreOrder: boolean;
  isLoading?: boolean;
  confirmButtonText?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, onClose, onConfirm, data, isPreOrder, isLoading, confirmButtonText }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          margin: 2,
        },
      }}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="text-lg font-semibold text-gray-900">{t('SEAT_INFO_FINAL_CONFIRMATION')}</h2>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </div>

      {/* Content */}
      <DialogContent>
        <div className="flex flex-col gap-5">
          <SeatContent data={data} isPreOrder={isPreOrder} />

          {/* Confirm Button */}
          <button
            onClick={onConfirm}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors mt-4"
            disabled={isLoading}
          >
            {confirmButtonText || t('SEAT_INFO_CONFIRM_START_ORDER')}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
